import { render, staticRenderFns } from "./VerifyCancelReceipt.vue?vue&type=template&id=12bbaf6d"
import script from "./VerifyCancelReceipt.vue?vue&type=script&lang=js"
export * from "./VerifyCancelReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports